// extracted by mini-css-extract-plugin
export default {"creatorSingleImage":"DetailPage_creatorSingleImage__GBQ0o","creatorSingleImageText":"DetailPage_creatorSingleImageText__8tED3"};